import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import { LOGO_URL, api } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLang();
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/settings").then(({ data }) => setS(data)).catch(() => {});
  }, []);

  const wa = s?.whatsapp || "9825708561";
  return (
    <footer className="relative border-t border-pink-200 bg-pink-50 pt-16 pb-8 mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <img src={LOGO_URL} alt="Metrix" className="h-14 w-auto mb-5" />
          <p className="text-zinc-600 text-sm max-w-sm leading-relaxed">{t("footer_tag")}</p>
          <p className="mt-3 inline-flex items-center gap-1.5 text-xs font-medium text-gold bg-pink-100 border border-pink-200 rounded-full px-3 py-1.5" data-testid="footer-service-area">
            <MapPin size={13} className="shrink-0" /> {t("service_area")}
          </p>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase text-gold mb-4">{t("nav_packages")}</h4>
          <ul className="space-y-2.5 text-sm text-zinc-600">
            <li><Link to="/packages" className="hover:text-gold transition-colors">{t("nav_packages")}</Link></li>
            <li><Link to="/gallery" className="hover:text-gold transition-colors">{t("nav_gallery")}</Link></li>
            <li><Link to="/inquiry" className="hover:text-gold transition-colors">{t("nav_inquiry")}</Link></li>
            <li><Link to="/track" className="hover:text-gold transition-colors">{t("nav_track")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase text-gold mb-4">{t("nav_contact")}</h4>
          <ul className="space-y-3 text-sm text-zinc-600">
            <li className="flex gap-2.5"><MapPin size={16} className="text-gold shrink-0 mt-0.5" /><span>6th Floor, Premier House, SG Highway, Bodakdev, Ahmedabad</span></li>
            <li className="flex gap-2.5 items-center"><Phone size={16} className="text-gold shrink-0" /><a href={`tel:${wa}`} className="hover:text-gold">{wa}</a></li>
            <li className="flex gap-2.5 items-center"><MessageCircle size={16} className="text-gold shrink-0" /><a href={`https://wa.me/91${wa}`} target="_blank" rel="noreferrer" className="hover:text-gold">WhatsApp</a></li>
            <li className="flex gap-2.5 items-center"><Mail size={16} className="text-gold shrink-0" /><span>{s?.email}</span></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-12 pt-6 border-t border-pink-100 flex flex-col sm:flex-row justify-between gap-3 text-xs text-zinc-500">
        <span>© {new Date().getFullYear()} Metrix Event Management Services. All rights reserved.</span>
        <Link to="/admin/login" className="hover:text-gold transition-colors" data-testid="footer-admin-link">Admin Login</Link>
      </div>
    </footer>
  );
}
